import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { ExecutiveReportData } from '@/types/executiveReport'

export const executiveReportKeys = {
  all: ['executive-report'] as const,
  data: (tenantId: string, period: number) =>
    [...executiveReportKeys.all, tenantId, period] as const,
}

export function useExecutiveReport(
  tenantId: string | undefined,
  periodDays: number = 30
) {
  return useQuery<ExecutiveReportData>({
    queryKey: executiveReportKeys.data(tenantId!, periodDays),
    queryFn: () => api.getExecutiveReportData(tenantId!, periodDays),
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000,
  })
}
